const config = {
    dev : {
        APP_NAME: "Digitales Arbeitsblatt Dev",
        APP_HOST_URL: "https://localhost:3002",
        API_HOST_URL: "https://localhost:8080",
        KEYCLOAK_AUTH_CALLBACK: "https://localhost:8080/users/auth/callback",
        KEYCLOAK_URL: "https://bauth.bauabc.de",
        KEYCLOAK_REALM: "bauth_staging",
        KEYCLOAK_CLIENT_ID: "bauth-public",
        TEILNEHMERPORTAL_URL: "http://localhost:3000",
        WORKER_URL: "https://staging-worker.bauabc.de",
        PRADLE_PDF_EXPORT_TOKEN : "KJHjzgrfdjzTURC7645dczfzcZasdg",
        API_MESSSAGE_SHOW_TIMER: 60000, //milliseconds
        TOAST_MESSSAGE_SHOW_TIMER: 5000, //milliseconds
        STEP_INTERVAL_TIMER: 10000, //milliseconds
        REGEX_FOR_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
        VALIDATION_MESSAGE_ON_PASSWORD_REGEX: "Muss mindestens 6 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl",
    } ,
    dev_prod : {
        APP_NAME: "Digitales Arbeitsblatt Dev-Prod",
        APP_HOST_URL: "https://localhost:3002",
        API_HOST_URL: "https://localhost:8080",
        KEYCLOAK_AUTH_CALLBACK: "https://localhost:8080/users/auth/callback",
        KEYCLOAK_URL: "https://bauth.bauabc.de",
        KEYCLOAK_REALM: "bauth",
        KEYCLOAK_CLIENT_ID: "bauth-public",
        TEILNEHMERPORTAL_URL: "http://localhost:3000",
        WORKER_URL: "https://worker.bauabc.de",
        PRADLE_PDF_EXPORT_TOKEN : "KJHjzgrfdjzTURC7645dczfzcZasdg",
        API_MESSSAGE_SHOW_TIMER: 60000, //milliseconds
        TOAST_MESSSAGE_SHOW_TIMER: 5000, //milliseconds
        STEP_INTERVAL_TIMER: 10000, //milliseconds
        REGEX_FOR_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
        VALIDATION_MESSAGE_ON_PASSWORD_REGEX: "Muss mindestens 6 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl",
    } ,
    dev_staging : {
        APP_NAME: "Digitales Arbeitsblatt Dev-Staging",
        APP_HOST_URL: "https://localhost:3002",
        API_HOST_URL: "https://localhost:8080",
        KEYCLOAK_AUTH_CALLBACK: "https://localhost:8080/users/auth/callback",
        KEYCLOAK_URL: "https://bauth.bauabc.de",
        KEYCLOAK_REALM: "bauth_staging",
        KEYCLOAK_CLIENT_ID: "bauth-public",
        TEILNEHMERPORTAL_URL: "http://localhost:3000",
        WORKER_URL: "https://worker.bauabc.de",
        PRADLE_PDF_EXPORT_TOKEN : "KJHjzgrfdjzTURC7645dczfzcZasdg",
        API_MESSSAGE_SHOW_TIMER: 60000, //milliseconds
        TOAST_MESSSAGE_SHOW_TIMER: 5000, //milliseconds
        STEP_INTERVAL_TIMER: 10000, //milliseconds
        REGEX_FOR_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
        VALIDATION_MESSAGE_ON_PASSWORD_REGEX: "Muss mindestens 6 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl",
    } ,
    staging : {
        APP_NAME: "Digitales Arbeitsblatt Staging",
        APP_HOST_URL: "https://staging-my.ausbildung.cloud",
        API_HOST_URL: "https://staging-api-my.ausbildung.cloud",
        KEYCLOAK_AUTH_CALLBACK: "https://staging-api-my.ausbildung.cloud/users/auth/callback",
        KEYCLOAK_URL: "https://bauth.bauabc.de",
        KEYCLOAK_REALM: "bauth_staging",
        KEYCLOAK_CLIENT_ID: "bauth-public",
        TEILNEHMERPORTAL_URL: "https://staging-my.bauabc.de",
        WORKER_URL: "https://staging-worker.bauabc.de",
        PRADLE_PDF_EXPORT_TOKEN : "KJHjzgrfdjzTURC7645dczfzcZasdg",
        API_MESSSAGE_SHOW_TIMER: 60000, //milliseconds
        TOAST_MESSSAGE_SHOW_TIMER: 5000, //milliseconds
        STEP_INTERVAL_TIMER: 10000, //milliseconds
        REGEX_FOR_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
        VALIDATION_MESSAGE_ON_PASSWORD_REGEX: "Muss mindestens 6 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl",
    } ,
    production : {
        APP_NAME: "Digitales Arbeitsblatt",
        APP_HOST_URL: "https://my.ausbildung.cloud",
        API_HOST_URL: "https://api-my.ausbildung.cloud",
        KEYCLOAK_AUTH_CALLBACK: "https://api-my.ausbildung.cloud/users/auth/callback",
        KEYCLOAK_URL: "https://bauth.bauabc.de",
        KEYCLOAK_REALM: "bauth",
        KEYCLOAK_CLIENT_ID: "bauth-public",
        TEILNEHMERPORTAL_URL: "https://my.bauabc.de",
        WORKER_URL: "https://worker.bauabc.de",
        PRADLE_PDF_EXPORT_TOKEN : "KJHjzgrfdjzTURC7645dczfzcZasdg",
        API_MESSSAGE_SHOW_TIMER: 60000, //milliseconds
        TOAST_MESSSAGE_SHOW_TIMER: 5000, //milliseconds
        STEP_INTERVAL_TIMER: 10000, //milliseconds
        REGEX_FOR_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
        VALIDATION_MESSAGE_ON_PASSWORD_REGEX: "Muss mindestens 6 Zeichen enthalten, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl",
    }
};
console.log("#############################################################################");
console.log({ production: 'p', staging: 's', development: 'd' }[process.env.REACT_APP_ENV]);
console.log("#############################################################################");
export default config[process.env.REACT_APP_ENV || 'production'];